import { ButtonProps } from 'antd';
import { ReactNode } from 'react';
import { mapClasses } from '../../utils/styles';
import './style.scss';

export type Props = ButtonProps['style'] & {
  children: ReactNode;
  type?:
    | 'primary'
    | 'secondary'
    | 'default'
    | 'disabled'
    | 'danger'
    | 'link'
    | 'outlined';
  small?: boolean;
  onClick?: () => void;
  classes?: string;
  disabled?: boolean;
  htmlType?: 'button' | 'submit' | 'reset';
};

export const Button = ({
  children,
  small,
  onClick,
  type = 'default',
  classes = '',
  htmlType,
  disabled,
  ...style
}: Props) => {
  const mappedClasses = mapClasses({ type, small });

  return (
    <button
      onClick={onClick}
      className={`tru-button ${mappedClasses} ${classes}`}
      type={htmlType}
      disabled={disabled}
      style={style}
    >
      <span>{children}</span>
    </button>
  );
};
